import { render } from "./Flat1.vue?vue&type=template&id=3a61de28"
import script from "./Flat1.vue?vue&type=script&lang=js"
export * from "./Flat1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__